
export const conditionToValueMap = {
    'NEW': 'Brand New',
    'NEW_OTHER': 'New (Other)',
    'NEW_WITH_DEFECTS': 'New with Defects',
    'CERTIFIED_REFURBISHED': 'Certified Refurbished',
    'EXCELLENT_REFURBISHED': 'Excellent Refurbished',
    'VERY_GOOD_REFURBISHED': 'Very Good Refurbished',
    'GOOD_REFURBISHED': 'Good Refurbished',
    'SELLER_REFURBISHED': 'Seller Refurbished',
    'LIKE_NEW': 'Like New',
    'PRE_OWNED_EXCELLENT': 'Pre-Owned - Excellent',
    'USED_EXCELLENT': 'Used - Excellent Condition',
    'PRE_OWNED_FAIR': 'Pre-Owned - Fair',
    'USED_VERY_GOOD': 'Used - Very Good Condition',
    'USED_GOOD': 'Used - Good Condition',
    'USED_ACCEPTABLE': 'Used - Acceptable Condition',
    'FOR_PARTS_OR_NOT_WORKING': 'For Parts or Not Working'
}
export const conditionKeys = Object.keys(conditionToValueMap)
export const conditionValues = Object.values(conditionToValueMap)

// Human-readable label for a raw eBay condition enum value. Never render the raw enum to users.
export const conditionDisplayLabel = (condition) => {
    if (!condition) return ''
    if (conditionToValueMap[condition]) return conditionToValueMap[condition]
    const str = String(condition)
    // Only prettify things that look like enums (USED_EXCELLENT); leave plain-English values alone.
    if (!/^[A-Z0-9_]+$/.test(str)) return str
    return str.replace(/_/g, ' ').toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase())
}
// Other constants
export const constants = {
  EXCLUDE_FROM_PRODUCT_TERMS: ['unknown', 'not applicable', 'not provided', 'not available', 'not specified']
};


// Define the getDropdownOptions function
export const getDropdownOptions = (field, specs) => {
  if (field === 'Condition') {
    return conditionValues || [];
  }
  if (field === 'Category' || field === 'PrimaryCategory') {
    return specs?.gptCategories?.allPotentialCategories || [];
  }

  // Default return for other fields
  return [];
};


// Define the getDropdownOptions function
export const translateDropdownOptions = (field, value) => {
  if (field === 'Condition') {
    return conditionDisplayLabel(value)
  }
  return value;
};

export const KNOWN_CATEGORIES = ['handbags', 'watches', 'jewelry', 'shoes', 'default'];

export const CATEGORY_LABELS = {
  handbags: 'Handbags',
  watches: 'Watches',
  jewelry: 'Jewelry',
  shoes: 'Shoes',
  default: 'Default',
};

// Mirrors the category-matching logic in format_utils.py:update_body_html()
export const normalizeCategoryKey = (categoryStr) => {
  if (!categoryStr) return 'default';
  const c = categoryStr.toLowerCase();
  if (c.includes('handbag') || c.includes('bag') || c.includes('purse') || c.includes('wallet')) return 'handbags';
  if (c.includes('watch')) return 'watches';
  if (c.includes('jewelry') || c.includes('jewellery') || c.includes('ring') || c.includes('necklace') || c.includes('bracelet') || c.includes('earring')) return 'jewelry';
  if (c.includes('shoe') || c.includes('sneaker') || c.includes('boot') || c.includes('heel') || c.includes('sandal')) return 'shoes';
  return 'default';
};
